import { StorageKey } from 'src/constants/storage';

export const getSelectedLegalEntityUri = () => sessionStorage.getItem(StorageKey.SELECTED_ENTITY_URI) ?? '';
